import { Organization } from "../types/organization";
import { Person } from "../types/person";

export function getResidencyWithinDate<
  T extends { fromDate: Date; toDate?: Date },
>(residency: T[], date: Date): T | undefined {
  return residency.find(
    ({ fromDate, toDate }) =>
      fromDate <= date && (toDate === undefined || toDate >= date),
  );
}

export function formatResidentNames(
  residents: { person?: Person; organization?: Organization }[],
): string {
  return residents
    .reduce((acc: string[], resident) => {
      const name = resident.organization?.name || resident.person?.lastName;
      if (name && !acc.includes(name)) {
        return [...acc, name];
      }
      return acc;
    }, [])
    .join(", ");
}

export function formatResidencyName(residency: {
  customName?: string;
  owners?: { person?: Person; organization?: Organization }[];
  tenants?: { person?: Person; organization?: Organization }[];
}): string {
  return (
    residency.customName ||
    formatResidentNames(residency.owners ?? residency.tenants ?? [])
  );
}
